export const XEP_LOAI_LABELS = {
  xuatSac: '🟣 Xuất Sắc',
  gioi: '🔵 Giỏi',
  kha: '🟢 Khá',
  trungBinh: '🟡 Trung Bình',
  yeu: '🔴 Yếu',
};

export const XEP_LOAI_COLORS = {
  xuatSac:   { bg: '#F5F3FF', text: '#5B21B6', border: '#DDD6FE' },
  gioi:      { bg: '#EEF2FF', text: '#3730A3', border: '#C7D2FE' },
  kha:       { bg: '#ECFDF5', text: '#065F46', border: '#BBF7D0' },
  trungBinh: { bg: '#FFFBEB', text: '#92400E', border: '#FDE68A' },
  yeu:       { bg: '#FEF2F2', text: '#991B1B', border: '#FECACA' },
};

export const NHAN_BAN_LABELS = {
  xuatSac:    '⭐⭐⭐⭐ Xuất sắc',
  tot:        '⭐⭐⭐ Tốt',
  kha:        '⭐⭐ Khá',
  canCoGang:  '⭐ Cần cố gắng',
};